export default function Spacing() {
    return (
        <div className='spacing'></div>
    );
}